import { prismicClient } from '@/data';
import { usePrismicStaleTime } from '@/data/prismicHooks';
import { useActiveProductConfig } from '@/hooks/use-active-product';
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';

type Props = ['banner', string | undefined];

const fetcher = async (context: QueryFunctionContext<Props>) => {
    const [key, rescueBannerUid] = context.queryKey;

    const rescueBannerContent = await prismicClient.getByUID(key, rescueBannerUid ?? '');

    return {
        content: rescueBannerContent.data,
    };
};

/**
 * Hook to fetch the rescue banner info from Prismic
 */
export const useRescueBannerInfo = () => {
    const productConfig = useActiveProductConfig();
    const staleTime = usePrismicStaleTime();

    const { data, isPending, refetch } = useQuery({
        queryKey: ['banner', productConfig?.rescueBannerUid],
        queryFn: fetcher,
        staleTime,
    });

    return {
        title: data?.content?.banner_title,
        description: data?.content?.banner_text,
        enabled: data?.content?.enabled,
        isPending,
        refetch,
    };
};
